// ABOUTME: Responsive featured roles component with clean card layout
// ABOUTME: Displays job cards with company logos and referral bonuses

import React from 'react';
import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
interface JobRole {
  id: string;
  title: string;
  department: string;
  location: string;
  priority: string;
  bonus_amount?: string;
  deadline?: string;
  Company?: string;
}
interface FeaturedRolesProps {
  roles: JobRole[];
  onViewChange?: (view: string) => void;
}
const FeaturedRoles = ({
  roles,
  onViewChange
}: FeaturedRolesProps) => {
  const handleReferNowClick = (role: JobRole) => {
    if (onViewChange) {
      onViewChange('submit');
    }
  };

  const formatBonus = (bonus?: string) => {
    if (!bonus) return '$0';
    const num = parseFloat(bonus);
    return `$${num.toLocaleString()}`;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {roles.length > 0 ? (
        roles.map(role => (
          <div 
            key={role.id} 
            className="border-2 border-border bg-background rounded-lg p-6 flex flex-col space-y-4 hover:shadow-md transition-shadow"
          >
            {/* Company Logo and Job Info */}
            <div className="flex gap-4">
              <div className="w-16 h-16 bg-muted rounded-lg flex items-center justify-center flex-shrink-0">
                {role.Company ? (
                  <span className="text-2xl font-bold text-foreground">
                    {role.Company.charAt(0).toUpperCase()}
                  </span>
                ) : (
                  <Building2 className="w-8 h-8 text-muted-foreground" />
                )}
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-foreground text-lg mb-1 line-clamp-2">
                  {role.title}
                </h3>
                <p className="text-sm text-muted-foreground truncate">
                  {role.department}
                </p>
                <p className="text-sm text-muted-foreground truncate">
                  {role.location}
                </p>
              </div>
            </div>

            {/* Referral Bonus */}
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground font-medium">
                Referral Bonus
              </p>
              <p className="text-2xl font-bold text-foreground">
                {formatBonus(role.bonus_amount)}
              </p>
            </div>

            {/* See More Roles Button */}
            <Button 
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg h-11 font-medium"
              onClick={() => handleReferNowClick(role)}
            >
              See More Roles
            </Button>
          </div>
        ))
      ) : (
        <div className="col-span-full text-center py-12 text-muted-foreground">
          <p>No hot jobs available</p>
        </div>
      )}
    </div>
  );
};
export default FeaturedRoles;